import { Grid } from '@material-ui/core';
import { Button, Col, Row } from 'antd';
import React from 'react';
import DetailItem from '../../../../CSIComponents/DetailItem';
import styles from '../../index.module.css'

const MeetingRatesView = (props: any) => {
    const detailData = [
        { label: 'Honor Special Negotiated Transient Rate', value: props.ratesData.honorspecialrate, span: 6 },
        { label: 'Convention/Meeting Package Rates', value: props.ratesData.conventionpkgrates, span: 6 },
        { label: 'Day Meeting Package Rates', value: props.ratesData.daymtgpkgrates, span: 6 },
        { span: 5 },
        { label: 'Discount off Best Available Rates (Percent)', value: props.ratesData.discountoffbestrates, span: 6 },
        { span: 5 },
    ]

    return (
        <>
            <div className={styles.outCon}>
                <div className={styles.inCon}>
                    <div style={{ fontWeight: 600, fontSize: 14, color: '#333', paddingLeft: '10px' }}>Meeting Rates</div>
                    <Button type='primary' className='db-edit-btn' onClick={() => { props.setEditFlag(true); window.editFunction(); props.setOneNavDisabled(true) }}>Edit</Button>
                </div>
                <Grid item xs={12} className={styles.pdLeft}>
                    <Row gutter={24}>
                        {detailData.map((item, i) => {
                            return item.label ? <Col span={item.span} key={i} className="col-margin">
                                <DetailItem value={item.value} label={item.label} />
                            </Col> : <Col span={item.span} key={i}></Col>
                        })
                        }
                    </Row>
                </Grid>
            </div>
        </>
    )
}
export default MeetingRatesView;
